"use client";

import Image from "next/image";
import MoonIcon from "@/images/landing-redesign/theme-moon.svg";
import SunIcon from "@/images/landing-redesign/theme-sun.svg";
import {useLandingTheme} from "./LandingThemeContext";

export function LandingThemeToggle() {
  const { theme, toggleTheme } = useLandingTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      className="rh-theme-toggle inline-flex h-10 w-[76px] cursor-pointer items-center gap-0.5 overflow-hidden rounded-full border-0 bg-black/5 p-[3px]"
      onClick={toggleTheme}
      aria-label={
        isDark ? "Enable light theme" : "Enable dark theme"
      }
      aria-pressed={isDark}
      title={isDark ? "Light Mode" : "Dark Mode"}
    >
      <span
        className={`grid size-[34px] flex-none place-items-center overflow-hidden rounded-full transition-colors duration-200 ${!isDark ? "bg-[#3c6e71]" : "bg-transparent"}`}
        aria-hidden="true"
      >
        <Image
          className={isDark ? "brightness-0 opacity-[.58]" : ""}
          src={SunIcon}
          alt=""
          width={17}
          height={17}
        />
      </span>
      <span
        className={`grid size-[34px] flex-none place-items-center overflow-hidden rounded-full transition-colors duration-200 ${isDark ? "bg-[#3c6e71]" : "bg-transparent"}`}
        aria-hidden="true"
      >
        <Image
          className={isDark ? "brightness-0 invert" : ""}
          src={MoonIcon}
          alt=""
          width={18}
          height={18}
        />
      </span>
    </button>
  );
}
